{
  "title": "Conjure Volley",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "150 feet",
  "components": "V, S, M (one piece of ammunition or one thrown weapon)",
  "duration": "Instantaneous",
  "description": [
    "You fire a piece of nonmagical ammunition from a ranged weapon or throw a nonmagical weapon into the air and choose a point within range. Hundreds of duplicates of the ammunition or weapon fall in a volley from above and then disappear. Each creature in a 40-foot-radius, 20-foot-high cylinder centered on that point must make a Dexterity saving throw. A creature takes 8d8 damage on a failed save, or half as much damage on a successful one. The damage type is the same as that of the ammunition or weapon."
  ],
  "spellLists": ["ranger"]
}
